import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";

const SeasonDetailsForm = (props) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [seasonName, setSeasonName] = useState("");
  const [startMonth, setStartMonth] = useState("");
  const { sendRequest: postSeasonDetails } = useHttp();
  const [endMonth, setEndMonth] = useState("");
  const [description, setDescription] = useState("");
  const [isCurrentSeason, setisCurrentSeason] = useState(false);


  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      seasonName: seasonName,
      seasonStartMonth: startMonth,
      seasonEndMonth: endMonth,
      description: description,
      isCurrentSeason: isCurrentSeason ? 1 : 0,

      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,
    };

    //console.log("data",data);

    if (props.update) {
      data["seasonId"] = props.update.seasonId;
    }

    postSeasonDetails(
      {
        url: "/api/seasons/",
        method: props.update ? "PUT" : "POST",

        body: data,
      },
      (res) => {
        toast.success(`Season Details ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    //console.log(props.update);
    if (props.update) {
      setSeasonName(props.update.seasonName);

      setStartMonth(props.update.seasonStartMonth);

      setEndMonth(props.update.seasonEndMonth);

      setDescription(props.update.description);

      setisCurrentSeason(props.update.isCurrentSeason === 1);

    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Season Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Season Name</label>
                        <input
                          type={"text"}
                          id={"seasonName"}
                          required
                          className="form-control"
                          value={seasonName}
                          onChange={(e) => {
                            setSeasonName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Season Start Month </label>
                        <select
                          id="calculationType"
                          className="form-control"
                          required
                          value={startMonth}
                          onChange={(e) => {
                            setStartMonth(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {months.map((month, index) => (
                            <option key={index} value={month}>
                              {month}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Season End Month </label>

                        <select
                          id="calculationAs"
                          className="form-control"
                          required
                          value={endMonth}
                          onChange={(e) => {
                            setEndMonth(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {months.map((month, index) => (
                            <option key={index} value={month}>
                              {month}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Description </label>
                        <input
                          type={"text"}
                          id={"seasonName"}
                          required
                          className="form-control"
                          value={description}
                          onChange={(e) => {
                            setDescription(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> isCurrentSeason </label>
                        <input
                          type={"text"}
                          id={"seasonName"}
                          required
                          className="form-control"
                          value={isCurrentSeason}
                          onChange={(e) => {
                            setisCurrentSeason(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div> */}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Description</label>
                        <input
                          type="text"
                          className="form-control"
                          value={description}
                          required
                          onChange={(e) => setDescription(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group" style={{ marginTop: "32px" }}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="isCurrentSeason"
                            checked={isCurrentSeason}
                            onChange={(e) => setisCurrentSeason(e.target.checked)}
                          />

                          <label className="font-weight-bold" htmlFor="isCurrentSeason">
                            Is Current Season
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>



                <div className="row">
                  <div className="col-md-1">
                    {" "}
                    <button
                      className="btn  btn-primary mx-2 my-2"
                      type="submit"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </section>
      </div>
    </>
  );
};
export default SeasonDetailsForm;
